<template>
    <div id="FormQuestion">
        <div
            class="content-container text-prompt-container d-flex flex-column align-items-center animate__animated animate__fadeIn">
            <h3 class="pb-5 brand-text align-self-center text-center" v-if="question.id !== 'DGB005'">{{ question.title ? question.title : question.text
            }}</h3>
            <h3 class="pb-5 brand-text align-self-center text-center" v-else>{{ manualEntryPrefilled ? 'Your NHS GP details' : question.title 
            }}</h3>
            <p class="pb-5 text-center" v-html="question.subtitle" v-if="question.id !== 'DGB005'"></p>
            <p class="pb-5 text-center" v-else>{{ manualEntryPrefilled ? 'Please check these details are correct' : question.subtitle
            }}</p>
            <div class="w-100" v-for="(item, i) in question.items">
                <div class="question-title">{{ item.label }}</div>
                <input class="question-input w-100" v-model="answers[i]" type="text" v-if="item.type === 'input'" />
                <div class="d-flex flex-column" v-else-if="item.type === 'textarea'">
                    <textarea v-model="answers[i]" rows="5" class="text-input d-block w-100" maxlength="600"></textarea>
                    <div class="text-remaining">{{ answers[i] ? 600 - answers[i].length : 600 }} characters remaining</div>
                </div>
                <div class="d-flex flex-column" v-else-if="item.type === 'date'">
                    <h3 class="pb-5 brand-text align-self-start">When did your symptoms start?</h3>
                    <p class="pb-3 align-self-start">Don't worry if you can't remember the exact date, just try to be as
                        accurate as you can.</p>
                    <input class="question-input w-100" v-model="answers[i]" type="date" id="datePickerId" />
                </div>
                <div v-else-if="item.type === 'file'" class="mt-5">
                    <div
                        class="content-container text-prompt-container d-flex flex-column animate__animated animate__fadeIn">
                        <h3 class="pb-5 brand-text align-self-start">Add photos (optional)</h3>
                        <p class="pb-5 align-self-start">Add up to five photos that may help the clinician understand
                            your concern. Make sure the photos are clear and in focus. Please do NOT share any photos of
                            intimate areas, e.g. genitalia or breast.</p>
                        <div>
                            <b-button v-if="answers[i] ? answers[i].length === 0 : true" variant="cta-outline mb-5"
                                size="lg" squared @click="clickImageFormButton">Upload
                                +</b-button>
                        </div>
                        <div class="pb-5 d-flex flex-row row mx-0" v-if="answers[i] ? answers[i].length !== 0 : false">
                            <div class="d-flex flex-column align-items-center mr-2 mb-3 preview-image-container"
                                v-for="(url, j) in answers[i]">
                                <img class="img-fluid preview-image mr-3" :src="url" />
                                <span class="image-delete" @click="deleteImage(url, i, j)"><i
                                        class="fa-solid fa-circle-xmark"></i></span>
                            </div>
                            <div class="extra-image-button d-flex flex-wrap align-items-center">
                                <i class="fa-solid fa-circle-plus fa-3x brand-primary "
                                    v-if="answers[i] ? answers[i].length > 0 && answers[i].length < 5 : false"
                                    @click="clickImageFormButton()"></i>
                            </div>
                        </div>
                        <input type="file" id="imgupload" accept="image/*" :ref="'file-' + i"
                            class="form-control-file d-none" multiple v-on:change="handleFileUpload(i)">
                    </div>
                </div>
                <div v-if="item.type === 'textarea' || item.type === 'input'">
                    <div class="py-3 px-4 error-container mb-4 text-left"
                        v-if="(answers[i] === '' || answers[i] === undefined) && showErrors">
                        <i class="fa-solid fa-triangle-exclamation"></i> {{ item.error_message }}
                    </div>
                </div>
                <div v-if="item.type === 'date'">
                    <div v-if="showErrors || showFutureDateError">
                        <div class="py-3 px-4 error-container mb-4 text-left"
                            v-if="(answers[i] === '' || answers[i] === undefined)">
                            <i class="fa-solid fa-triangle-exclamation"></i> {{ item.error_message_on_blank }}
                        </div>
                        <div class="py-3 px-4 error-container mb-4 text-left" v-else-if="showFutureDateError">
                            <i class="fa-solid fa-triangle-exclamation"></i> {{ item.error_message }}
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>
<script>

import axios from "axios"
import config from "../../config/constants"
import moment from "moment";

export default {
    components: {
    },
    name: "FormQuestion",
    data() {
        return {
            text: '',
            answers: [],
            photo: {},
            url: null,
            photos: [],
            showFutureDateError: false,
        };
    },
    mounted() {
        if(this.manualEntry){
            let self = this;
            this.questionAnswer.items.forEach((answer, i) => {
                    self.answers[i] = answer.value;
            })
            this.generateAnswer();
            this.$forceUpdate();
        }else if (this.loadedAnswer) {
            let self = this;
            this.loadedAnswer.forEach((answer, i) => {
                if (answer.type === 'file') {
                    self.answers[i] = answer.value === '' ? [] : answer.value;
                } else {
                    self.answers[i] = answer.value;
                }
            })
            this.generateAnswer();
            this.$forceUpdate();
        }
        datePickerId.max = new Date().toISOString().split("T")[0];
    },
    beforeDestroy() {

    },
    methods: {
        handleFileUpload(id) {
            let tooLarge = false;
            const ref = 'file-' + id;
            const refs = this.$refs;
            const filesEle = refs[ref];
            const files = filesEle[0].files;
            let answers = this.answers[id] ? this.answers[id] : [];
            if ((files.length + answers.length) > 5) {
                alert("No more than 5 images at a time");
            } else {
                for (let i = 0; i < files.length; i++) {
                    if (files[i].size >= 2097152) {
                        tooLarge = true;
                    }
                }
                if (tooLarge) {
                    alert("No files over 2mb allowed");
                } else {
                    for (let i = 0; i < files.length; i++) {
                        this.uploadFile(files[i], id);
                    }
                }
            }
        },
        clickImageFormButton() {
            document.getElementById("imgupload").click();
        },
        async uploadFile(file, i) {
            console.log('uploadFile')
            let form = new FormData();
            form.set('img[]', file)
            let res = await axios.post(
                config.matchtech_api_env + "/quiz/upload",
                form,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "Authorization": `Bearer ${localStorage.getItem('bearerToken')}`
                    }
                }
            );
            if (res.data.urls) {
                if (this.answers[i] === undefined) {
                    this.answers[i] = [];
                }
                this.answers[i].push(res.data.urls[0]);
                this.generateAnswer();
            } else if (res.data.start_sso_journey) {
                this.openErrorModal('Your session has expired', "Please log in and try again.", true);
            } else if (res.data.err && res.data.err.includes("3994")) {
                this.openErrorModal('Your session has expired', "Please log in and try again.", true);
            } else {
                this.openErrorModal("Sorry, we've had a problem", "Please try again. <br /> <br /> If the problem persists please call us on <b>0345 608 0898</b>. We’re here to help Mon-Fri 8am-6pm, Sat 8am-4pm");
            }
        },
        async deleteImage(url, i, j) {
            let res = await axios.delete(
                config.matchtech_api_env + "/quiz/delete-user-files",
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "Authorization": `Bearer ${localStorage.getItem('bearerToken')}`
                    }
                },
                { files: [url] },
            );
            if (res.status === 200) {

                this.answers[i].splice(j, 1);
                this.generateAnswer();
            } else if (res.data.start_sso_journey) {
                this.openErrorModal('Your session has expired', "Please log in and try again.", true);
            } else if (res.data.err && res.data.err.includes("3994")) {
                this.openErrorModal('Your session has expired', "Please log in and try again.", true);
            } else {
                this.openErrorModal("Sorry, we've had a problem", "Please try again. <br /> <br /> If the problem persists please call us on <b>0345 608 0898</b>. We’re here to help Mon-Fri 8am-6pm, Sat 8am-4pm");
            }
        },
        generateAnswer() {
            console.log('generateAnswer hit');
            let items = []
            let newAnswers = this.answers;
            this.question.items.forEach((item, i) => {
                items.push({ type: item.type, value: newAnswers[i] ? newAnswers[i] : '' })
            })
            this.updateAnswer({ question_id: this.question.id, items: items })
            this.$forceUpdate();
        },
    },
    watch: {
        answers(newAnswers) {
            let items = []
            let self = this
            this.question.items.forEach((item, i) => {
                items.push({ type: item.type, value: newAnswers[i] ? newAnswers[i] : '' })
                if (item.type === 'date') {
                    self.showFutureDateError = moment(newAnswers[i]).isAfter(moment());
                }
            })
            this.updateAnswer({ question_id: this.question.id, items: items })
        },
        loadedAnswer() {
            if (this.loadedAnswer) {
                let self = this;
                this.loadedAnswer.forEach((answer, i) => {
                    self.answers[i] = answer.value;
                })
                this.generateAnswer();
                this.$forceUpdate();
            }
        },
    },

    props: ['question', 'updateAnswer', 'showErrors', 'loadedAnswer', 'dateError', 'manualEntry', 'manualEntryPrefilled', 'questionAnswer'],
};
</script>
<style lang="less">
#FormQuestion {
    .text-prompt-container {
        max-width: 700px;
        font-size: 1.6rem;

        h3 {
            padding-top: 0;
            margin-top: 0;
            letter-spacing: normal;
            font-size: 1.8rem;
        }

        .warning-info-container {
            font-family: "Montserrat", serif;
            font-weight: 700;
            background-color: white;
            padding: 20px;
            border: 2px solid #D60023;
            border-radius: 16px;
            margin-bottom: 25px;

            i {
                color: #D60023;
            }
        }

        .btn {
            margin-top: 30px;
            margin-bottom: 100px;
        }

        .error-container {

            width: 100%;
            background-color: #fbeacf;
            border-radius: 6px;

            i {
                color: red;
            }
        }
    }

    .text-remaining {
        padding-top: 5px;
        float: right;
        width: 100%;
        text-align: right;
        font-size: 1.4rem;
        color: #aaa;
        padding-bottom: 10px;
    }

    .question-title {
        font-weight: 500;
        padding-bottom: 5px;
        text-align: left;
    }

    .question-input {
        border-radius: 6px;
        padding: 5px;
        border: 1px solid #dde1e6;
        margin-bottom: 20px;
    }

    .text-remaining {
        padding-top: 5px;
        width: 100%;
        text-align: right;
        font-size: 1.4rem;
        color: #aaa;
        padding-bottom: 10px;
    }

    textarea {
        border-radius: 6px;
        padding: 5px;
        border: 1px solid #dde1e6;
        resize: none;
    }

    .extra-image-button {
        height: 150px;
        margin-left: 10px;
    }

    .preview-image-container {
        position: relative;

        .image-delete {
            cursor: pointer;
            display: none;
            position: absolute;
            top: -5px;
            right: 0;

            i {
                font-size: 2rem;
                color: red;
            }
        }

        &:hover {
            .image-delete {
                display: flex;
            }
        }
    }

    .preview-image {
        max-width: 150px;
        min-width: 150px;
        min-height: 150px;
        max-height: 150px;
        object-fit: scale-down;
        border-radius: 16px;
        background-color: white;
    }
}
</style>